import type { Account, Transaction, UserProfile } from '@/types/account.types';

export const FETCH_ACCOUNT_SUMMARY_REQUEST = 'account/FETCH_ACCOUNT_SUMMARY_REQUEST' as const;
export const FETCH_ACCOUNT_SUMMARY_SUCCESS = 'account/FETCH_ACCOUNT_SUMMARY_SUCCESS' as const;
export const FETCH_ACCOUNT_SUMMARY_FAILURE = 'account/FETCH_ACCOUNT_SUMMARY_FAILURE' as const;

export const FETCH_ACCOUNTS_REQUEST = 'account/FETCH_ACCOUNTS_REQUEST' as const;
export const FETCH_ACCOUNTS_SUCCESS = 'account/FETCH_ACCOUNTS_SUCCESS' as const;
export const FETCH_ACCOUNTS_FAILURE = 'account/FETCH_ACCOUNTS_FAILURE' as const;

export const FETCH_RECENT_TRANSACTIONS_REQUEST = 'account/FETCH_RECENT_TRANSACTIONS_REQUEST' as const;
export const FETCH_RECENT_TRANSACTIONS_SUCCESS = 'account/FETCH_RECENT_TRANSACTIONS_SUCCESS' as const;
export const FETCH_RECENT_TRANSACTIONS_FAILURE = 'account/FETCH_RECENT_TRANSACTIONS_FAILURE' as const;

export const FETCH_USER_PROFILE_REQUEST = 'account/FETCH_USER_PROFILE_REQUEST' as const;
export const FETCH_USER_PROFILE_SUCCESS = 'account/FETCH_USER_PROFILE_SUCCESS' as const;
export const FETCH_USER_PROFILE_FAILURE = 'account/FETCH_USER_PROFILE_FAILURE' as const;

export const SET_SELECTED_ACCOUNT = 'account/SET_SELECTED_ACCOUNT' as const;
export const CLEAR_ACCOUNT_ERROR = 'account/CLEAR_ACCOUNT_ERROR' as const;
export const RESET_ACCOUNT_STATE = 'account/RESET_ACCOUNT_STATE' as const;
export const LOGOUT_REQUEST = 'account/LOGOUT_REQUEST' as const;

export interface FetchAccountSummarySuccessAction {
  type: typeof FETCH_ACCOUNT_SUMMARY_SUCCESS;
  payload: { accounts: Account[]; selectedAccount: Account | null };
}

export interface FetchAccountsSuccessAction {
  type: typeof FETCH_ACCOUNTS_SUCCESS;
  payload: Account[];
}

export interface FetchRecentTransactionsSuccessAction {
  type: typeof FETCH_RECENT_TRANSACTIONS_SUCCESS;
  payload: Transaction[];
}

export interface FetchUserProfileSuccessAction {
  type: typeof FETCH_USER_PROFILE_SUCCESS;
  payload: UserProfile;
}

export interface SetSelectedAccountAction {
  type: typeof SET_SELECTED_ACCOUNT;
  payload: Account | null;
}

export interface FailureAction {
  type:
    | typeof FETCH_ACCOUNT_SUMMARY_FAILURE
    | typeof FETCH_ACCOUNTS_FAILURE
    | typeof FETCH_RECENT_TRANSACTIONS_FAILURE
    | typeof FETCH_USER_PROFILE_FAILURE;
  payload: string;
}

export interface FetchAccountSummaryRequestAction {
  type: typeof FETCH_ACCOUNT_SUMMARY_REQUEST;
  payload: string;
}

export interface FetchRecentTransactionsRequestAction {
  type: typeof FETCH_RECENT_TRANSACTIONS_REQUEST;
  payload: string;
}

export interface RequestAction {
  type:
    | typeof FETCH_ACCOUNTS_REQUEST
    | typeof FETCH_USER_PROFILE_REQUEST
    | typeof CLEAR_ACCOUNT_ERROR
    | typeof RESET_ACCOUNT_STATE
    | typeof LOGOUT_REQUEST;
}

export type AccountActionTypes =
  | RequestAction
  | FetchAccountSummaryRequestAction
  | FetchRecentTransactionsRequestAction
  | FetchAccountSummarySuccessAction
  | FetchAccountsSuccessAction
  | FetchRecentTransactionsSuccessAction
  | FetchUserProfileSuccessAction
  | SetSelectedAccountAction
  | FailureAction;

export const fetchAccountSummaryRequest = (payload: string): FetchAccountSummaryRequestAction => ({
  type: FETCH_ACCOUNT_SUMMARY_REQUEST,
  payload,
});

export const fetchAccountSummarySuccess = (
  payload: FetchAccountSummarySuccessAction['payload']
): FetchAccountSummarySuccessAction => ({
  type: FETCH_ACCOUNT_SUMMARY_SUCCESS,
  payload,
});

export const fetchAccountSummaryFailure = (payload: string) => ({
  type: FETCH_ACCOUNT_SUMMARY_FAILURE,
  payload,
});

export const fetchAccountsRequest = () => ({
  type: FETCH_ACCOUNTS_REQUEST,
});

export const fetchAccountsSuccess = (payload: Account[]): FetchAccountsSuccessAction => ({
  type: FETCH_ACCOUNTS_SUCCESS,
  payload,
});

export const fetchAccountsFailure = (payload: string) => ({
  type: FETCH_ACCOUNTS_FAILURE,
  payload,
});

export const fetchRecentTransactionsRequest = (payload: string): FetchRecentTransactionsRequestAction => ({
  type: FETCH_RECENT_TRANSACTIONS_REQUEST,
  payload,
});

export const fetchRecentTransactionsSuccess = (
  payload: Transaction[]
): FetchRecentTransactionsSuccessAction => ({
  type: FETCH_RECENT_TRANSACTIONS_SUCCESS,
  payload,
});

export const fetchRecentTransactionsFailure = (payload: string) => ({
  type: FETCH_RECENT_TRANSACTIONS_FAILURE,
  payload,
});

export const fetchUserProfileRequest = () => ({
  type: FETCH_USER_PROFILE_REQUEST,
});

export const fetchUserProfileSuccess = (payload: UserProfile): FetchUserProfileSuccessAction => ({
  type: FETCH_USER_PROFILE_SUCCESS,
  payload,
});

export const fetchUserProfileFailure = (payload: string) => ({
  type: FETCH_USER_PROFILE_FAILURE,
  payload,
});

export const setSelectedAccount = (payload: Account | null): SetSelectedAccountAction => ({
  type: SET_SELECTED_ACCOUNT,
  payload,
});

export const clearAccountError = () => ({
  type: CLEAR_ACCOUNT_ERROR,
});

export const resetAccountState = () => ({
  type: RESET_ACCOUNT_STATE,
});

export const logoutRequest = () => ({
  type: LOGOUT_REQUEST,
});
